exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000; }\n  .modal-backdrop.fade {\n    opacity: 0;\n    filter: alpha(opacity=0); }\n  .modal-backdrop.in {\n    opacity: 0.5;\n    filter: alpha(opacity=50); }\n\n.tl-dialog.tl-full-screen-dialog {\n  z-index: 99999; }\n  .tl-dialog.tl-full-screen-dialog .tl-spinner {\n    height: 100vh; }\n  .tl-dialog.tl-full-screen-dialog .modal-dialog {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0; }\n  .tl-dialog.tl-full-screen-dialog .modal-content {\n    height: auto;\n    min-height: 100%;\n    border-radius: 0; }\n\n.tl-dialog .close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 10; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/vendor/treeline-shared-components/dialog/dialog.scss
 ** module id = 778
 ** module chunks = 1 2 108
 **/